import React, { FC } from "react";
import { MenuItem as MuiMenuItem, MenuItemProps } from "@mui/material";

const MenuItem: FC<MenuItemProps> = (props) => <MuiMenuItem {...props} />;

export default MenuItem;
